import { useState, useEffect } from "react";
import IC_MODAL_CLOSE from "@/assets/simulInter/ic_modal_close.svg?react";

interface DeviceControlModalProps {
  visible: boolean;
  webviewUrl?: string; // webview 的 URL
  isWsConnected: boolean; // WebSocket 连接状态
  onClose: () => void; // 关闭回调
}

const DeviceControlModal = (props: DeviceControlModalProps) => {
  const { visible, webviewUrl, isWsConnected, onClose } = props;
  const [loadError, setLoadError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // 当 webviewUrl 变化时重置状态
  useEffect(() => {
    setLoadError(false);
    setIsLoading(true);
  }, [webviewUrl]);

  const handleIframeLoad = () => {
    console.log("iframe 加载成功");
    setIsLoading(false);
    setLoadError(false);
  };

  const handleIframeError = (
    e: React.SyntheticEvent<HTMLIFrameElement, Event>
  ) => {
    console.error("iframe 加载失败:", e);
    setIsLoading(false);
    setLoadError(true);

    // 检测是否是 Mixed Content 问题
    const isMixedContent =
      window.location.protocol === "https:" && webviewUrl?.startsWith("http:");

    if (isMixedContent) {
      console.error(
        "由于安全策略限制，HTTPS 页面无法加载 HTTP 内容。请确保设备控制服务使用 HTTPS 协议，或在新窗口中打开。"
      );
    } else {
      console.error("无法加载设备控制页面，请检查设备连接和网络状态");
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    // 点击背景遮罩时关闭
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center" onClick={handleBackdropClick}>
      {/* 遮罩层 */}
      <div className="absolute inset-0 bg-black/50" />

      {/* 弹窗内容 */}
      <div className="relative flex flex-col bg-white w-148 h-122.75 rounded-4 shadow overflow-hidden">
        {/* 头部 */}
        <div className="relative flex items-center justify-between h-16 px-6">
          <div className="font-600 text-4.5 lh-6 text-mx-secondary">
            设备控制
          </div>
          <div
            className="absolute right-4 top-4 cursor-pointer"
            onClick={onClose}
          >
            <IC_MODAL_CLOSE className="w-8 h-8" />
          </div>
        </div>

        {/* WebView 内容区域 */}
        <div className="flex-1 overflow-hidden relative px-6 pb-4">
          {isWsConnected && webviewUrl && !loadError ? (
            <>
              {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-#F5F6F7 rounded-2 z-10">
                  <div className="text-center">
                    <div className="text-4 text-#626773">加载中...</div>
                  </div>
                </div>
              )}
              <iframe
                src={webviewUrl}
                className="w-full h-full border-0"
                title="设备控制"
                // sandbox="allow-scripts allow-forms allow-popups allow-pointer-lock allow-modals"
                referrerPolicy="no-referrer"
                onLoad={handleIframeLoad}
                onError={handleIframeError}
                style={{ pointerEvents: 'auto' }}
              />
            </>
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-#F5F6F7 rounded-2">
              <div className="text-center">
                <div className="text-4 text-#626773 mb-2">暂无设备控制内容</div>
                <div className="text-3 text-#9CA3AF">
                  {!isWsConnected
                    ? "请确保已连接设备"
                    : loadError
                      ? "设备控制服务加载失败，请检查设备连接"
                      : "请确保已连接设备"}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeviceControlModal;
